// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const CryptoPaymentsIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "CryptoPayments/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M23 15.22c-.41 0-.75.34-.75.75 0 2.96-2.06 5.44-4.83 6.09l.27-.45a.751.751 0 1 0-1.29-.77l-1.05 1.75c-.14.23-.14.52-.01.75.13.24.38.38.65.38 4.27 0 7.75-3.48 7.75-7.75a.74.74 0 0 0-.74-.75ZM8 .22C3.73.22.25 3.7.25 7.97c0 .41.34.75.75.75s.75-.34.75-.75c0-2.96 2.06-5.44 4.83-6.09l-.27.45a.751.751 0 1 0 1.29.77l1.05-1.75c.13-.23.14-.51 0-.75A.752.752 0 0 0 8 .22ZM21.5 8.67c0 3.08-2.24 5.62-5.17 6.09v-.02c-.29-3.73-3.31-6.77-7.09-7.07a6.158 6.158 0 0 1 6.09-5.17c3.41 0 6.17 2.76 6.17 6.17ZM9.81 14.2c0-.15-.17-.38-.38-.38H7.37v.75h2.06c.21.01.38-.16.38-.37ZM9.83 16.08H7.37v.75h2.47c.32 0 .54-.2.54-.38s-.23-.37-.55-.37Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.83 14.85a6.174 6.174 0 0 0-5.68-5.68c-.16-.01-.31-.02-.48-.02a6.17 6.17 0 0 0-6.17 6.18c0 3.41 2.76 6.17 6.17 6.17s6.18-2.76 6.18-6.17c0-.17-.01-.32-.02-.48Zm-5 3.48h-.66v.38c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-.38H6.62c-.41 0-.75-.34-.75-.75v-4.5c0-.41.34-.75.75-.75h1.05v-.38c0-.41.34-.75.75-.75s.75.34.75.75v.38h.26c1 0 1.88.88 1.88 1.88 0 .29-.07.56-.19.81.46.34.75.86.75 1.44 0 1.03-.91 1.87-2.04 1.87Z"
}));
export default CryptoPaymentsIcon;